export const colors = {
  text: "rgb(61, 59, 73)",
  grayBackground: "rgb(238, 242, 246)",
  grayBackgroundGradient:
    "linear-gradient(to top, rgb(255,255,255), rgb(238, 242, 246)",
  blue: "rgb(0, 113, 235)",
  blueGradient:
    "radial-gradient(31.94% 34.84% at 38.89% 29.17%, rgb(0, 84, 181) 0%, rgb(0, 113, 235) 100%)",
};
